<template>
  <div :class="{ 'form-loading': loading }">
    <window-header></window-header>
    <nav style="justify-content: space-between;">
      <r-progressbar :value="progressbar" v-if="progressbar"></r-progressbar>
      <template v-else>
        <button class="button button-fill" @click="abrirConfiguracion">
          <fa-icon icon="filter" /><span>Filtros</span>
        </button>
        <div style="display: flex; align-items: center;">{{ hotInstance ? (hotInstance.getSourceData().length + ' ' +
          (hotInstance.getSourceData().length == 1 ?
            'piedra' : 'piedras')) : '' }}</div>
        <!--<div style="display: flex;">
          <label style="display: flex; align-items: center;">
            <input type="checkbox" name="inactivos" v-model="mostrarInactivos" @change="actualizar">
            <span style="margin-left: 5px;">Mostrar inactivos</span>
          </label>
          <label style="display: flex; align-items: center; margin-left: 15px;">
            <input type="checkbox" name="sin_stock" v-model="mostrarSinStock" @change="actualizar">
            <span style="margin-left: 5px;">Mostrar sin stock</span>
          </label>
        </div>-->
        <button class="button button-fill" @click="guardar">
          <fa-icon icon="save" /> <span>Guardar</span>
        </button>
      </template>
    </nav>
    <section>
      <article style="height: 536px; width: 975px">
        <div ref="hotTableComponent"></div>
      </article>
    </section>
  </div>
</template>

<script>
import WindowMixin from "./../components/WindowMixin.vue";
import Handsontable from "handsontable";

export default {
  mixins: [WindowMixin],
  data: function () {
    return {
      title: "Precios de piedras",
      hotInstance: null,
      loading: false,
      mostrarInactivos: false,
      mostrarSinStock: false,
      progressbar: 0,
      actualizar: null,
    };
  },
  methods: {
    guardar() {
      let self = this;
      let data = self.hotInstance.getSourceData().filter(d => d.changed)
      if (!data.length) {
        self.app.toast("No se ha modificado ninguna línea", "error")
        return;
      }
      self.loading = true;
      let p = Promise.resolve();
      data.forEach((item, i) => {
        p = p.then(_ => {
          self.progressbar = Math.floor((i * 100) / data.length);
          return window.DB.put('certificado_articulo', {
            itemId: item.id, data: {
              precio: item.precio
            }
          })
        });
      })
      p
        .catch(e => self.app.toast("Error al actualizar los datos", "error"))
        .then(_ => self.app.toast("Datos actualizados", "success"))
        .finally(_ => {
          self.loading = false
          self.progressbar = 0
        })
    },
    abrirConfiguracion() {
      var self = this;
      self.app.openChildWindow("certificados_precios_config", self.win, {
        backdrop: true,
        //model: self.model,
        props: {
          parent: self,
        },
      });
    },
  },
  mounted() {
    var self = this;

    self.filtro = null;

    self.actualizar = (forceVal) => {
      self.loading = true;
      let filter = [];
      /*if (!self.mostrarInactivos) filter.push(['activo', '=', 1])
      if (!self.mostrarSinStock) filter.push(['stock', '>', 0])*/
      if (self.filtro) filter.push(self.filtro);
      window.DB.getList('certificado_articulo', {
        filter, order: 'id', fields: [
          { name: 'naturaleza', fields: ['descripcion'] },
          { name: 'talla', fields: ['descripcion'] },
          'npiedras',
          'pesogema',
          { name: 'color', fields: ['descripcion'] },
          { name: 'pureza', fields: ['descripcion'] },
          'tamano_mm',
          'precio',
          //{ name: 'articulo_id', fields: ['codigo'] }
        ]
      }).then(resArt => {
        let data = resArt.data.map(a => ({ ...a, ...{ changed: typeof forceVal != 'undefined' } }));

        //console.log(data.filter(a => !a.naturaleza || !a.talla || !a.color || !a.pureza || !a.pesogema).map(a => a.articulo_id?.codigo));

        // Eliminar repetidos
        const seen = new Set();
        data = data.filter(a => {
          const pesogema2 = (a.pesogema || 0).toFixedNumber(2)
          const key = [a.naturaleza?.codigo, a.talla?.codigo, a.color?.codigo, a.pureza?.codigo, pesogema2].join('|');
          if (seen.has(key)) {
            //console.log(key)
            return false;
          }
          seen.add(key);
          return true;
        });

        data.forEach(a => {
          ['naturaleza', 'talla', 'color', 'pureza'].forEach(x => {
            if (a[x]) {
              self.hotInstance.cachedItems ||= {};
              self.hotInstance.cachedItems[x] ||= {};
              self.hotInstance.cachedItems[x][a[x].codigo] = a[x]
              a[x] = a[x].codigo;
            }
          })

        })
        //window.console.log(data)
        self.hotInstance.loadData(data);
      }).finally(_ => self.loading = false)
    }

    const rowHeaderWidth = 40;
    const checkboxWidth = 35;
    const wNaturaleza = 100;
    const wTalla = 100;
    const wColor = 100;
    const wPureza = 100;
    const wtamano = 100;
    const wPrecio = 100;
    const wTotal = 100;
    const descripcionWidth = Math.max(975 - rowHeaderWidth - 10 - wNaturaleza - wTalla - wColor - wPureza - wtamano - wPrecio - wTotal, 200);
    const colHeaders = ['Naturaleza', 'Talla', 'Color', 'Pureza', 'Peso (ct)', 'Precio', 'Total'];
    const colWidths = checkboxWidth;
    let columns = [
      {
        data: 'naturaleza',
        header: 'Naturaleza',
        type: 'm2o',
        label: 'descripcion',
        primary: 'codigo',
        showCode: true,
        readOnly: true,
        width: wNaturaleza,
        renderer: function (hotInstance, td, row, column, prop, value, cellProperties) {
          Handsontable.renderers.M2oRenderer.apply(this, arguments);
          let r = self.hotInstance?.toPhysicalRow(row) || row;
          if (hotInstance.getSourceDataAtRow(r).changed) td.style.backgroundColor = '#fff3bb';
        },
      },
      {
        data: 'talla',
        model: 'talla',
        header: 'Talla',
        type: 'm2o',
        label: 'descripcion',
        primary: 'codigo',
        readOnly: true,
        width: wTalla
      },
      /*{
        name: 'npiedras',
        header: 'N. Piedras',
        type: 'numeric',
        numericFormat: { pattern: '0,0.' },
      },
      {
        data: 'pesogema',
        header: 'Peso Gema',
        type: 'numeric',
        numericFormat: { pattern: '0,0.000' },
        sufix: ' ct',
        readOnly: true,
        width: w1
      },*/
      {
        data: 'color',
        header: 'Color',
        type: 'm2o',
        label: 'descripcion',
        primary: 'codigo',
        readOnly: true,
        width: wColor
      },
      {
        data: 'pureza',
        header: 'Pureza',
        type: 'm2o',
        label: 'descripcion',
        primary: 'codigo',
        readOnly: true,
        width: wPureza
      },
      {
        //data: 'pesogema',
        data: row => row.pesogema / (row.npiedras || 1),
        header: 'Peso (mm)',
        type: 'numeric',
        numericFormat: { pattern: '0,0.0000' },
        sufix: ' mm',
        readOnly: true,
        width: wtamano
      },
      {
        data: 'precio',
        header: 'Precio',
        type: 'numeric',
        numericFormat: { pattern: '0,0.00' },
        sufix: ' mm',
        width: wPrecio
      },
      {
        data: (v) => (v.precio || 0) * (v.pesogema || 0) / (v.npiedras || 1),
        header: 'Total',
        type: 'numeric',
        numericFormat: { pattern: '0,0.00' },
        sufix: ' mm',
        width: wPrecio,
        readOnly: true,
      },

    ];

    self.hotInstance = new Handsontable(self.$refs.hotTableComponent, {
      licenseKey: 'non-commercial-and-evaluation',
      //autoRowSize: { syncLimit: 300 },
      dataSchema: { codigo: null, nombre: null },
      multiSelect: true,
      rowHeaders: true,
      width: 975,
      height: 535,
      columnSorting: true,
      sortIndicator: true,
      manualColumnResize: true,
      manualColumnMove: true,
      fillHandle: {
        //direction: 'vertical',
        autoInsertRow: false,
      },
      fixedColumnsLeft: 1,
      columns,
      colHeaders,
      colWidths,
      data: [],
      minRows: 0,
      minSpareRows: 0,
      beforeChange: (changes, source) => changes.forEach(c => changes.push([c[0], 'changed', null, 1])),
      rowHeights: 21,
      enterBeginsEditing: false,
      autoWrapCol: false,
      autoWrapRow: false,
      rowHeaderWidth,
      copyPaste: {
        rowsLimit: Infinity,
      },
      //renderAllRows: true,
      afterSelectionEnd: row => {
        row = self.hotInstance?.toPhysicalRow(row) || row;
        if (parseInt(self.app.config.mostrar_imagen_articulos_ocultos)) {
          let h = self.hotInstance;
          let articulo_id = h.getSourceData()[row].codigo;
          if (!articulo_id) return;
          let a = h.getSourceData()[row];
          if (self.win.children.length && self.win.children.some(ch => ch.window_name == 'popup_imagen')) {
            let popupImagen = self.win.children.find(ch => ch.window_name == 'popup_imagen');
            if (popupImagen.instance) popupImagen.instance.articulo = a;
            else popupImagen.opts.articulo = a;
          } else {
            let p = self.interactPosition;
            let $el = self.win.instance.$el;
            self.app.openChildWindow('popup_imagen', self.win, {
              backdrop: false,
              resizable: true,
              articulo: a,
              x: $el.offsetWidth + p.x,
              y: p.y
            })
          }
        }
      },
    });
    self.actualizar();
  },
};
</script>

<style>
.text-align-center {
  text-align: center;
}
</style>